// components/AlreadySignedScreen.js
import { Box, Typography, Paper, Button } from "@mui/material";
import Logo from "../assets/logo.png";
import PdfViewer from "./PdfViewer";

export default function AlreadySignedScreen({ document }) {
  if (!document) return null;

  const handlePrintPdf = () => {
    const pdfUrl = document.downloadUrl; // eller Blob-URL om du hämtar via getPdf
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #7AB2D3, #b3e5fc)",
        py: 4,
        px: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box textAlign="center" mb={4}>
        <img
          src={Logo}
          alt="OceanLogix"
          style={{ width: 160, marginBottom: 12 }}
        />
        <Typography variant="h4" fontWeight="bold">
          eSign by OceanLogix
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This document has already been signed.
        </Typography>
      </Box>

      <Paper
        elevation={4}
        sx={{
          width: "100%",
          maxWidth: 900,
          p: 2,
          backgroundColor: "#fafafa",
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" mb={2}>
          Document: {document.documentName}
        </Typography>
        <PdfViewer url={document.downloadUrl} />
        <Button variant="contained" sx={{ mt: 3 }} onClick={handlePrintPdf}>
          Print Document
        </Button>
      </Paper>
    </Box>
  );
}
